export default "__VITE_ASSET__6434bcc8__"